import React from "react";
// import './homepage.css'
import { Box, Button, Grid, } from "@mui/material";
import { styled } from "@mui/material/styles";
import Carousel, { useCarousel, CarouselDots, CarouselArrows } from '../carousel';
import HeroTwo from "./HeroTwo";
import HeroOne from "./HeroOne";
import HeroThree from "./HeroThree";
import HeroFour from "./HeroFour";
import HeroFive from "./HeroFive";
import HeroSix from "./HeroSix";
import Iconify from "../iconify";

export default function HeroSection() {

  const carousel = useCarousel({
    autoplay: true,
    ...CarouselDots({
      rounded: true,
      // sx: { mt: {sm:5, xs:5}},
    }),
  });
  const handleFreeTrialClick = () => {
    const selectedPlan = "Free Trial"; // Only store the plan name

    sessionStorage.setItem("selectedPlan", selectedPlan);
    window.location.href = "/paymenthome"; // Redirect to the payment plan page
  };


  const FreeTrial = styled(Button)(({ theme }) => ({
    backgroundColor: "#C7F760",
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "& .icon-hover": {
      transition: "color 0.3s ease",
    },
    "&:hover": {
      backgroundColor: "#1E53E8",
      color: "#C7F760",
      "& .icon-hover": {
        color: "#FFFFFF", // Change the icon color to white on hover
      },
    },
  }));

  return (
    <Box
      sx={{
        overflow: 'hidden',
        position: 'relative',
        // '& .slick-list': {
        //   borderRadius: 2,
        //   // boxShadow: theme.shadows[16],
        // },
        // borderRadius: "8px",
        // padding: {sm:'10px 0px 0px 0px', xs:'10px 0px 0px 0px',  xl: '80px 90px', md: '115px' },
        padding: { sm: '10px 10px', xs: '10px 10px', xl: '74.5px 109px 74.5px 109px', md: '74.5px 109px 74.5px 109px' },

      }}
    >
      <CarouselArrows shape="rounded" onNext={carousel.onNext} onPrev={carousel.onPrev}>
        <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
          <HeroTwo />
          <HeroOne />
          <HeroThree />
          <HeroFour />
          <HeroFive />
          <HeroSix />
        </Carousel>
      </CarouselArrows>
      <Box
        sx={{
          display: "flex",
          gap: "15px",
          pt: 5,
          justifyContent: "center",
        }}
      >
        <Grid container md={4} justifyContent='center'  >
          <FreeTrial
            onClick={handleFreeTrialClick}
            variant="contained"
            fullWidth
            size="large"
            sx={{
              color: "#1E53E8",
              fontWeight: "bold",
              background: "#C7F760",
              padding: 1,
              borderRadius: 2,
            }}
          >
            <Iconify icon="gg:microsoft" width="1.6em" height="1.6em" className="icon-hover" />&nbsp;Get Started for Free
          </FreeTrial>
        </Grid>
      </Box>
    </Box>

  )
}
